"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationDepthRequestPayloadToJSON = exports.NavigationDepthRequestPayloadFromJSONTyped = exports.NavigationDepthRequestPayloadFromJSON = void 0;
function NavigationDepthRequestPayloadFromJSON(json) {
    return NavigationDepthRequestPayloadFromJSONTyped(json, false);
}
exports.NavigationDepthRequestPayloadFromJSON = NavigationDepthRequestPayloadFromJSON;
function NavigationDepthRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'depth': json['depth'],
    };
}
exports.NavigationDepthRequestPayloadFromJSONTyped = NavigationDepthRequestPayloadFromJSONTyped;
function NavigationDepthRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'depth': value.depth,
    };
}
exports.NavigationDepthRequestPayloadToJSON = NavigationDepthRequestPayloadToJSON;
//# sourceMappingURL=NavigationDepthRequestPayload.js.map